import { Model } from '@df/catalog/model';
import { NUgcImage } from './ugc-image.namespace';

export class UgcImage extends Model<NUgcImage.IModelData, number> {
    static type = 'ugcImage';

    maxVerbosity = 1;

    protected set(data: NUgcImage.IModelData, verbosity: number): void {
        super.set(data, 1);
    }
}
